import { FUEL_GRADES, type FuelGrade } from './constants'

interface Props {
  grade: FuelGrade
  liters: string
  isFullTank: boolean
  amount: string
  fuelPrice: number | null
  onGrade: (g: FuelGrade) => void
  onLiters: (v: string) => void
  onFullTank: (v: boolean) => void
}

export default function FuelFields({
  grade, liters, isFullTank, amount, fuelPrice,
  onGrade, onLiters, onFullTank,
}: Props) {
  const estimated =
    fuelPrice && fuelPrice > 0 && amount
      ? (parseInt(amount, 10) / fuelPrice).toFixed(2)
      : null

  return (
    <div className="fuel-fields">
      {/* 油品選擇 */}
      <div className="field">
        <label>油品</label>
        <div className="grade-btns">
          {FUEL_GRADES.map(g => (
            <button
              key={g}
              type="button"
              className={`grade-btn${grade === g ? ' active' : ''}`}
              onClick={() => onGrade(g)}
            >
              {g} 無鉛
            </button>
          ))}
        </div>
      </div>

      {/* 估算公升 */}
      {estimated && !liters && (
        <p className="fuel-estimate">
          約 {estimated} 公升
          <span className="tag-estimate">估算</span>
          （{grade} 牌價 NT${fuelPrice}/L）
        </p>
      )}

      {/* 加滿開關 */}
      <label className="toggle-row">
        <input
          type="checkbox"
          checked={isFullTank}
          onChange={e => onFullTank(e.target.checked)}
        />
        加滿（用於計算油耗）
      </label>

      {/* 手動公升數（可選） */}
      <details className="field">
        <summary>輸入實際公升數（選填）</summary>
        <input
          inputMode="decimal"
          placeholder={estimated ?? '例：12.50'}
          value={liters}
          onChange={e => onLiters(e.target.value)}
          autoComplete="off"
        />
      </details>
    </div>
  )
}
